<template>
    <div class="moderators-list">
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Логін</th>
                    <th>Подія</th>
                    <th>Дія</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(m, index) in moderators" :key="index">
                    <td>{{index + 1}}</td>
                    <td>{{m.login}}</td>
                    <td>{{m.event.name}}</td>
                    <td>
                        <button type="button" class="remove" @click="removeModerator(m.id)">Видалити</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data : () => ({
        moderators : []
    }),
    mounted(){
        axios.interceptors.request.use((config) => {
            var token = sessionStorage.getItem('access_token');
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });

        axios.get(location.protocol + '/api/Admin/GetModerators')
        .then(response => {
            console.log(response);
            this.moderators = response.data;
        })
    },
    methods : {
        removeModerator(id){
            axios.interceptors.request.use((config) => {
                var token = sessionStorage.getItem('access_token');
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            });

            axios.delete(location.protocol + '/api/Admin/RemoveModerator/' + id)
            .then(response => {
                console.log(response);
                let moderatorForDel = this.moderators.filter(eObj => {
                    return eObj.id == id;
                });

                let index = this.moderators.indexOf(moderatorForDel);
                this.moderators.splice(index, 1);
            });
        }
    }
}
</script>

<style lang="scss">
.moderators-list{
    padding: 40px 60px;
}
</style>